import { Reducer } from 'react';
import { Actions } from '../../actions/jobProfile';
import { Action, JobProfileState } from '../../types';
import loadIcon from '../../../assets/loadIcon.png';
import lofaIcon from '../../../assets/lofaIcon.png';
import pumpIcon from '../../../assets/pumpIcon.png';
import notesIcon from '../../../assets/loadNotes.png';
import mileageIcon from '../../../assets/mileageIcon.png';
import vosIcon from '../../../assets/vosIcon.png';
import equipmentIcon from '../../../assets/equipmentIcon.png';

const initialJobProfileState: JobProfileState = {
    tabs: window.screen.width > 1199 ? [
        {
            key: 0,
            displayName: 'Load Summary',
            icon: loadIcon,
            isSelected: true,
        },
        {
            key: 1,
            displayName: 'LOFA Schedule',
            icon: lofaIcon,
            isSelected: false,
        },
        {
            key: 2,
            displayName: 'Pump Schedule',
            icon: pumpIcon,
            isSelected: false,
        },
        {
            key: 3,
            displayName: 'Notes',
            icon: notesIcon,
            isSelected: false,
        },
        {
            key: 4,
            displayName: 'Mileage Confirmation',
            icon: mileageIcon,
            isSelected: false,
        },
        {
            key: 5,
            displayName: 'Equipment',
            icon: equipmentIcon,
            isSelected: false,
        },
        {
            key: 6,
            displayName: 'VOS',
            icon: vosIcon,
            isSelected: false,
        },
    ] : [
        {
            key: 0,
            displayName: 'Load Summary',
            icon: loadIcon,
            isSelected: true,
        },
        {
            key: 1,
            displayName: 'LOFA Schedule',
            icon: lofaIcon,
            isSelected: false,
        },
        {
            key: 2,
            displayName: 'Pump Schedule',
            icon: pumpIcon,
            isSelected: false,
        },
        {
            key: 3,
            displayName: 'Notes',
            icon: notesIcon,
            isSelected: false,
        },
        {
            key: 4,
            displayName: 'Mileage Confirmation',
            icon: notesIcon,
            isSelected: false,
        },
    ]
};

const setSelectedTab = (payload: number, state: JobProfileState): JobProfileState => {
    return {
        ...state,
        tabs: state.tabs.map((tab): any => {
            const isSelected = tab.key === payload;
            return { ...tab, isSelected: isSelected };
        }),
    };
};

const jobProfileReducer: Reducer<JobProfileState, Action> = (state, action): JobProfileState => {
    let newState = { ...state };

    switch (action.type) {
        case Actions.SET_SELECTED_TAB:
            newState = setSelectedTab(action.payload, state);
            break;
    }

    return newState;
};

export { initialJobProfileState, jobProfileReducer };
